// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"sortDropdown_dropdown_17M3OO0","dropdownTrigger":"sortDropdown_dropdownTrigger_12nDtGv","dropdownIcon":"sortDropdown_dropdownIcon_1po7lww"};